
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiGenericLineDirection as ObiGenericLineDirectionElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-generic-line-direction.js';
 
 
 

 
 export const ObiGenericLineDirection = createComponent({
   react: React,
   tagName: 'obi-generic-line-direction',
   elementClass: ObiGenericLineDirectionElement,
   events: {
     
   }
  });
 
 